import React from 'react';
import { Modal } from '../../components';

export const ValidateWarningModal = (props) => {
    const { show, onClose, onValidate } = props;

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="p-4 min-w-min ml-4 mr-4 mt-2">
                <h1>Project have item(s) need validation</h1>
                <div className="mt-2 mb-6 px-2">
                    There are items that need validation after your change in
                    site info
                </div>
                <div className="px-4 py-3 sm:flex sm:px-6 justify-end">
                    <button
                        onClick={onClose}
                        type="button"
                        className="swegon-like-button outlined mr-4 !px-4 amber"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onValidate}
                        type="button"
                        className="swegon-like-button contained !px-4"
                    >
                        Validate
                    </button>
                </div>
            </div>
        </Modal>
    );
};
